/**
 * Seeq REST API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 66.224.0-v202611042144-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import type { SeeqRequestOverrides, SeeqErrorData } from '../variables';
import { getRuntime } from '../variables';
import type { AxiosPromise, AxiosError } from 'axios';
import { useMutation, useQuery, type UseMutationOptions, type UseMutationResult, type UseQueryOptions, type UseQueryResult } from '@tanstack/react-query';
import type { AxiosInstance } from 'axios';
import type * as models from '../model/models';

export class sqWorkbooksApiClass {
 
   constructor() {}

  /**
   * @summary Put the specified item at the top of the recently accessed list for the workbook
   * @param {string} workbookId - ID of the workbook
   * @param {string} itemId - Item to be added
  */
  public addRecentlyAccessed(
    {
      workbookId,
      itemId
    } : {
      workbookId: string,
      itemId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (itemId === null || itemId === undefined) {
      throw new Error("'itemId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/recently-accessed/${encodeURIComponent(String(itemId))}`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{itemId}', encodeURIComponent(String(itemId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/recently-accessed/{itemId}`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewListV1>;
  }

  /**
   * @summary Archive a workbook by id
   * @param {string} id - ID of the workbook to archive
  */
  public archiveWorkbook(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/workbooks/{id}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Archive a worksheet
   * @param {string} workbookId - ID of the workbook on which the worksheet exists
   * @param {string} worksheetId - ID of the worksheet to archive
  */
  public archiveWorksheet(
    {
      workbookId,
      worksheetId
    } : {
      workbookId: string,
      worksheetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}`;



    return axiosInstance.request({
      method: 'delete',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ArchiveOutputV1>;
  }

  /**
   * @summary Create a sandboxed copy of a Topic document. The new document will be placed in a new Topic in the personal folder of the user making the request. The Topic will be automatically archived and will not be visible in the user's list of Topics.
   * @param {string} workbookId - The ID of the original workbook
   * @param {string} worksheetId - The ID of the original worksheet
  */
  public createSandbox(
    body: models.TopicSandboxInputV1,
    {
      workbookId,
      worksheetId
    } : {
      workbookId: string,
      worksheetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/sandbox`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/sandbox`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.WorksheetOutputV1>;
  }

  /**
   * @summary Create a workbook
  */
  public createWorkbook(
    body: models.WorkbookInputV1,
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks`;
    const urlTemplate = `${baseUrl}/workbooks`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.WorkbookOutputV1>;
  }

  /**
   * @summary Create a worksheet
   * @param {string} workbookId - ID of the workbook on which to create the worksheet
  */
  public createWorksheet(
    body: models.WorksheetInputV1,
    {
      workbookId
    } : {
      workbookId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      ...restOverrides
    }) as AxiosPromise<models.WorksheetOutputV1>;
  }

  /**
   * @summary Forces the thumbnail to be regenerated. Normally new thumbnails are generated automatically as worksteps are added to the worksheet. However, thumbnail generation is normally limited to once a day, so this endpoint can be used to force a new thumbnail to be generated. When the thumbnail is complete a message will be sent over the thumbnail websocket channel.
   * @param {string} workbookId - The ID of the workbook for containing the worksheet
   * @param {string} worksheetId - The ID of the worksheet
  */
  public createWorksheetThumbnail(
    {
      workbookId,
      worksheetId
    } : {
      workbookId: string,
      worksheetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/thumbnail`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/thumbnail`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

  /**
   * @summary Append a new workstep to the worksheet
   * @param {string} workbookId - ID of the workbook on which the worksheet exists
   * @param {string} worksheetId - ID of the worksheet on which to append the new workstep
   * @param {boolean} [noWorkstepMessage=false] - Option to not send a workstep message notifying clients that the current workstep of the worksheet has been updated. Should only be used when multiple worksteps are being pushed in quick succession and a subsequent call will be made to set the current workstep.
  */
  public createWorkstep(
    body: models.WorkstepInputV1,
    {
      workbookId,
      worksheetId,
      noWorkstepMessage
    } : {
      workbookId: string,
      worksheetId: string,
      noWorkstepMessage?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/worksteps`;

    const queryParams = {
      ['noWorkstepMessage']: noWorkstepMessage
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      data: body,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkstepOutputV1>;
  }

  /**
   * @summary Get the recently accessed list for the workbook
   * @param {string} workbookId - ID of the workbook
  */
  public getRecentlyAccessed(
    {
      workbookId
    } : {
      workbookId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/recently-accessed`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/recently-accessed`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ItemSearchPreviewListV1>;
  }

  /**
   * @summary Get items referenced by workstep or a journal
   * @param {string} worksheetId - ID of the worksheet associated with journal that references items to return
   * @param {string} workstepId - ID of the workstep that references items to return
  */
  public getReferencedItems(
    {
      worksheetId,
      workstepId
    } : {
      worksheetId: string,
      workstepId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }

    if (workstepId === null || workstepId === undefined) {
      throw new Error("'workstepId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}/referenced-items`
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)))
      .replace('{workstepId}', encodeURIComponent(String(workstepId)));
    const urlTemplate = `${baseUrl}/workbooks/worksheets/{worksheetId}/worksteps/{workstepId}/referenced-items`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.ReferencedItemsOutputV1>;
  }

  /**
   * @summary Get a workbook
   * @param {string} id - ID of the workbook to retrieve
   * @param {boolean} [fullAncestry] - If true, the actual ancestor folders of the workbook will be returned, which includes the home folder of the relevant user. Otherwise, if a workbook is shared, then only the ancestors that are shared will be returned. Requires the Analytics Administration capability.
  */
  public getWorkbook(
    {
      id,
      fullAncestry
    } : {
      id: string,
      fullAncestry?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(id))}`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/workbooks/{id}`;

    const queryParams = {
      ['fullAncestry']: fullAncestry
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkbookOutputV1>;
  }

  /**
   * @summary Get owner information for a workbook, if user has access permissions of the owner
   * @param {string} id - ID of the workbook for which to retrieve owner information
  */
  public getWorkbookOwner(
    {
      id
    } : {
      id: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(id))}/owner`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/workbooks/{id}/owner`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.WorkbookOwnerOutputV1>;
  }

  /**
   * @summary Get a collection of workbooks
   * @param {string} [userId] - The user ID to return workbooks for, defaults to the current user if not specified. Only an admin user is allowed to specify a user ID.
   * @param {boolean} [isArchived=false] - True to filter results to only workbooks that have been archived, false to filter results to workbooks that are not archived.
   * @param {string} [sortOrder=createdAt asc] - A field by which to order the workbooks followed by a space and &#x27;asc&#x27; or &#x27;desc&#x27;. Field name can be one of: createdAt, updatedAt, name
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getWorkbooks(
    {
      userId,
      isArchived,
      sortOrder,
      offset,
      limit
    } : {
      userId?: string,
      isArchived?: boolean,
      sortOrder?: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {

    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks`;
    const urlTemplate = `${baseUrl}/workbooks`;

    const queryParams = {
      ['userId']: userId,      ['isArchived']: isArchived,      ['sortOrder']: sortOrder,      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkbookOutputListV1>;
  }

  /**
   * @summary Get a worksheet
   * @param {string} workbookId - ID of the workbook for which to retrieve the worksheets
   * @param {string} worksheetId - ID of the worksheet to retrieve
  */
  public getWorksheet(
    {
      workbookId,
      worksheetId
    } : {
      workbookId: string,
      worksheetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.WorksheetOutputV1>;
  }

  /**
   * @summary Get the thumbnail for this worksheet
   * @param {string} workbookId - The ID of the workbook for containing the worksheet
   * @param {string} worksheetId - The ID of the worksheet
  */
  public getWorksheetThumbnail(
    {
      workbookId,
      worksheetId
    } : {
      workbookId: string,
      worksheetId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/thumbnail`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/thumbnail`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<string>;
  }

  /**
   * @summary Get a list of reports that reference a given worksheet
   * @param {string} workbookId - The ID of the workbook for containing the worksheet
   * @param {string} worksheetId - The ID of the worksheet
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
  */
  public getWorksheetUsages(
    {
      workbookId,
      worksheetId,
      offset,
      limit
    } : {
      workbookId: string,
      worksheetId: string,
      offset?: number,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/usages`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/usages`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.AnnotationListOutputV1>;
  }

  /**
   * @summary Get a collection of worksheets
   * @param {string} workbookId - The ID of the workbook for which to retrieve the worksheets
   * @param {number} [offset=0] - The pagination offset, the index of the first collection item that will be returned in this page of results
   * @param {number} [limit=40] - The pagination limit, the total number of collection items that will be returned in this page of results
   * @param {boolean} [isArchived=false] - Whether to return archived worksheets
  */
  public getWorksheets(
    {
      workbookId,
      offset,
      limit,
      isArchived
    } : {
      workbookId: string,
      offset?: number,
      limit?: number,
      isArchived?: boolean
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets`;

    const queryParams = {
      ['offset']: offset,      ['limit']: limit,      ['isArchived']: isArchived
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorksheetOutputListV1>;
  }

  /**
   * @summary Get a workstep
   * @param {string} workbookId - ID of the workbook for which to retrieve the worksteps
   * @param {string} worksheetId - ID of the worksheet for which to retrieve the worksteps
   * @param {string} workstepId - ID of the workstep to retrieve
  */
  public getWorkstep(
    {
      workbookId,
      worksheetId,
      workstepId
    } : {
      workbookId: string,
      worksheetId: string,
      workstepId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }

    if (workstepId === null || workstepId === undefined) {
      throw new Error("'workstepId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)))
      .replace('{workstepId}', encodeURIComponent(String(workstepId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/worksteps/{workstepId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.WorkstepOutputV1>;
  }

  /**
   * @summary Get a workstep by its ID
   * @param {string} workstepId - ID of the workstep to retrieve
  */
  public getWorkstepById(
    {
      workstepId
    } : {
      workstepId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workstepId === null || workstepId === undefined) {
      throw new Error("'workstepId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/worksteps/${encodeURIComponent(String(workstepId))}`
      .replace('{workstepId}', encodeURIComponent(String(workstepId)));
    const urlTemplate = `${baseUrl}/workbooks/worksteps/{workstepId}`;



    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.WorkstepOutputV1>;
  }

  /**
   * @summary Get a list of worksteps starting from the given workstep, searching in the given direction.
   * @param {string} workbookId - ID of the workbook for which to retrieve the worksteps
   * @param {string} worksheetId - ID of the worksheet for which to retrieve the worksteps
   * @param {string} fromWorkstepId - ID of the workstep from where the search starts
   * @param {string} direction - The direction of the search to retrieve worksteps starting from the given one
   * @param {number} [limit=1000] - The maximum number of worksteps to be retrieved during the search.
  */
  public getWorksteps(
    {
      workbookId,
      worksheetId,
      fromWorkstepId,
      direction,
      limit
    } : {
      workbookId: string,
      worksheetId: string,
      fromWorkstepId: string,
      direction: GetWorkstepsDirectionEnum,
      limit?: number
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }

    if (fromWorkstepId === null || fromWorkstepId === undefined) {
      throw new Error("'fromWorkstepId' parameter required");
    }

    if (direction === null || direction === undefined) {
      throw new Error("'direction' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/worksteps`;

    const queryParams = {
      ['fromWorkstepId']: fromWorkstepId,      ['direction']: direction,      ['limit']: limit
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'get',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorkstepChronologyOutputV1>;
  }

  /**
   * @summary Move a Worksheet to a new location in the same Workbook
   * @param {string} workbookId - ID of the workbook on which the worksheet exists
   * @param {string} worksheetId - ID of the worksheet on which the workstep exists
   * @param {string} [nextWorksheetId] - ID of the worksheet that the specified worksheet should precede. If not supplied then the worksheet will be moved to be the last worksheet in the workbook.
  */
  public moveWorksheet(
    {
      workbookId,
      worksheetId,
      nextWorksheetId
    } : {
      workbookId: string,
      worksheetId: string,
      nextWorksheetId?: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/next`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/next`;

    const queryParams = {
      ['nextWorksheetId']: nextWorksheetId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.WorksheetOutputV1>;
  }

  /**
   * @summary Set the current workstep
   * @param {string} workbookId - ID of the workbook on which the worksheet exists
   * @param {string} worksheetId - ID of the worksheet on which the workstep exists
   * @param {string} workstepId - ID of the workstep to set as the current one
  */
  public setCurrentWorkstep(
    {
      workbookId,
      worksheetId,
      workstepId
    } : {
      workbookId: string,
      worksheetId: string,
      workstepId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (workbookId === null || workbookId === undefined) {
      throw new Error("'workbookId' parameter required");
    }

    if (worksheetId === null || worksheetId === undefined) {
      throw new Error("'worksheetId' parameter required");
    }

    if (workstepId === null || workstepId === undefined) {
      throw new Error("'workstepId' parameter required");
    }


    const { baseUrl, getAxiosInstance } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}/current`
      .replace('{workbookId}', encodeURIComponent(String(workbookId)))
      .replace('{worksheetId}', encodeURIComponent(String(worksheetId)))
      .replace('{workstepId}', encodeURIComponent(String(workstepId)));
    const urlTemplate = `${baseUrl}/workbooks/{workbookId}/worksheets/{worksheetId}/worksteps/{workstepId}/current`;



    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      ...restOverrides
    }) as AxiosPromise<models.WorkstepOutputV1>;
  }

  /**
   * @summary Set the topic's renderer.
   * @param {string} id - ID of the topic to change the renderer of
   * @param {string} userId - The user to make the topic&#x27;s renderer
  */
  public setRenderer(
    {
      id,
      userId
    } : {
      id: string,
      userId: string
    },
    requestOverrides?: SeeqRequestOverrides
  ) {
    if (id === null || id === undefined) {
      throw new Error("'id' parameter required");
    }

    if (userId === null || userId === undefined) {
      throw new Error("'userId' parameter required");
    }


    const { baseUrl, getAxiosInstance, serializeParams } = getRuntime();
    const { axiosInstance: overrideAxiosInstance, ...restOverrides } = requestOverrides ?? {};
    const axiosInstance = overrideAxiosInstance ?? getAxiosInstance();

    const url = `${baseUrl}/workbooks/${encodeURIComponent(String(id))}/renderer`
      .replace('{id}', encodeURIComponent(String(id)));
    const urlTemplate = `${baseUrl}/workbooks/{id}/renderer`;

    const queryParams = {
      ['userId']: userId
    };
    const filteredQueryParams = Object.fromEntries(
      Object.entries(queryParams).filter(([, value]) => value !== null && value !== undefined),
    );


    return axiosInstance.request({
      method: 'post',
      url,
      urlTemplate,
      params: filteredQueryParams,
      paramsSerializer: serializeParams,
      ...restOverrides
    }) as AxiosPromise<models.StatusMessageBase>;
  }

}

export const GetWorkstepsDirectionEnum = {
    Before: 'Before',
    After: 'After'
} as const;

export type GetWorkstepsDirectionEnum = typeof GetWorkstepsDirectionEnum[keyof typeof GetWorkstepsDirectionEnum];

export const sqWorkbooksApi = new sqWorkbooksApiClass();

export type sqWorkbooksApiEndpoints = {
  'addRecentlyAccessed': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/recently-accessed/${encodeURIComponent(String(itemId))}';
    response: models.ItemSearchPreviewListV1;
  };
  'archiveWorkbook': {
    method: 'delete';
    path: '/workbooks/${encodeURIComponent(String(id))}';
    response: models.ArchiveOutputV1;
  };
  'archiveWorksheet': {
    method: 'delete';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}';
    response: models.ArchiveOutputV1;
  };
  'createSandbox': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/sandbox';
    response: models.WorksheetOutputV1;
  };
  'createWorkbook': {
    method: 'post';
    path: '/workbooks';
    response: models.WorkbookOutputV1;
  };
  'createWorksheet': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets';
    response: models.WorksheetOutputV1;
  };
  'createWorksheetThumbnail': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/thumbnail';
    response: models.StatusMessageBase;
  };
  'createWorkstep': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps';
    response: models.WorkstepOutputV1;
  };
  'getRecentlyAccessed': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/recently-accessed';
    response: models.ItemSearchPreviewListV1;
  };
  'getReferencedItems': {
    method: 'get';
    path: '/workbooks/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}/referenced-items';
    response: models.ReferencedItemsOutputV1;
  };
  'getWorkbook': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(id))}';
    response: models.WorkbookOutputV1;
  };
  'getWorkbookOwner': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(id))}/owner';
    response: models.WorkbookOwnerOutputV1;
  };
  'getWorkbooks': {
    method: 'get';
    path: '/workbooks';
    response: models.WorkbookOutputListV1;
  };
  'getWorksheet': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}';
    response: models.WorksheetOutputV1;
  };
  'getWorksheetThumbnail': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/thumbnail';
    response: string;
  };
  'getWorksheetUsages': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/usages';
    response: models.AnnotationListOutputV1;
  };
  'getWorksheets': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets';
    response: models.WorksheetOutputListV1;
  };
  'getWorkstep': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}';
    response: models.WorkstepOutputV1;
  };
  'getWorkstepById': {
    method: 'get';
    path: '/workbooks/worksteps/${encodeURIComponent(String(workstepId))}';
    response: models.WorkstepOutputV1;
  };
  'getWorksteps': {
    method: 'get';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps';
    response: models.WorkstepChronologyOutputV1;
  };
  'moveWorksheet': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/next';
    response: models.WorksheetOutputV1;
  };
  'setCurrentWorkstep': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(workbookId))}/worksheets/${encodeURIComponent(String(worksheetId))}/worksteps/${encodeURIComponent(String(workstepId))}/current';
    response: models.WorkstepOutputV1;
  };
  'setRenderer': {
    method: 'post';
    path: '/workbooks/${encodeURIComponent(String(id))}/renderer';
    response: models.StatusMessageBase;
  };
};

type ApiAddRecentlyAccessedResponse = models.ItemSearchPreviewListV1;
type ApiaddRecentlyAccessedMutationParams = Parameters<typeof sqWorkbooksApi.addRecentlyAccessed> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.addRecentlyAccessed>;

export function useApiAddRecentlyAccessedMutation(
  options?: Omit<UseMutationOptions<ApiAddRecentlyAccessedResponse, AxiosError<SeeqErrorData>,
    ApiaddRecentlyAccessedMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiAddRecentlyAccessedResponse, AxiosError<SeeqErrorData>,
  ApiaddRecentlyAccessedMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiaddRecentlyAccessedMutationParams) =>
      sqWorkbooksApi.addRecentlyAccessed(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveWorkbookResponse = models.ArchiveOutputV1;
type ApiarchiveWorkbookMutationParams = Parameters<typeof sqWorkbooksApi.archiveWorkbook> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.archiveWorkbook>;

export function useApiArchiveWorkbookMutation(
  options?: Omit<UseMutationOptions<ApiArchiveWorkbookResponse, AxiosError<SeeqErrorData>,
    ApiarchiveWorkbookMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveWorkbookResponse, AxiosError<SeeqErrorData>,
  ApiarchiveWorkbookMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveWorkbookMutationParams) =>
      sqWorkbooksApi.archiveWorkbook(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiArchiveWorksheetResponse = models.ArchiveOutputV1;
type ApiarchiveWorksheetMutationParams = Parameters<typeof sqWorkbooksApi.archiveWorksheet> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.archiveWorksheet>;

export function useApiArchiveWorksheetMutation(
  options?: Omit<UseMutationOptions<ApiArchiveWorksheetResponse, AxiosError<SeeqErrorData>,
    ApiarchiveWorksheetMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiArchiveWorksheetResponse, AxiosError<SeeqErrorData>,
  ApiarchiveWorksheetMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApiarchiveWorksheetMutationParams) =>
      sqWorkbooksApi.archiveWorksheet(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateSandboxResponse = models.WorksheetOutputV1;
type ApicreateSandboxMutationParams = Parameters<typeof sqWorkbooksApi.createSandbox> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.createSandbox>;

export function useApiCreateSandboxMutation(
  options?: Omit<UseMutationOptions<ApiCreateSandboxResponse, AxiosError<SeeqErrorData>,
    ApicreateSandboxMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateSandboxResponse, AxiosError<SeeqErrorData>,
  ApicreateSandboxMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApicreateSandboxMutationParams) =>
      sqWorkbooksApi.createSandbox(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateWorkbookResponse = models.WorkbookOutputV1;
type ApicreateWorkbookMutationParams = Parameters<typeof sqWorkbooksApi.createWorkbook> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.createWorkbook>;
type ApicreateWorkbookMutationVariables = models.WorkbookInputV1;

export function useApiCreateWorkbookMutation(
  options?: Omit<UseMutationOptions<ApiCreateWorkbookResponse, AxiosError<SeeqErrorData>,
    ApicreateWorkbookMutationVariables>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateWorkbookResponse, AxiosError<SeeqErrorData>,
  ApicreateWorkbookMutationVariables> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (body: ApicreateWorkbookMutationVariables) =>
      sqWorkbooksApi.createWorkbook(body, resolvedOverrides).then((response) => response.data),
    
    
    
    ...mutationOptions,
  });
}
type ApiCreateWorksheetResponse = models.WorksheetOutputV1;
type ApicreateWorksheetMutationParams = Parameters<typeof sqWorkbooksApi.createWorksheet> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.createWorksheet>;

export function useApiCreateWorksheetMutation(
  options?: Omit<UseMutationOptions<ApiCreateWorksheetResponse, AxiosError<SeeqErrorData>,
    ApicreateWorksheetMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateWorksheetResponse, AxiosError<SeeqErrorData>,
  ApicreateWorksheetMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApicreateWorksheetMutationParams) =>
      sqWorkbooksApi.createWorksheet(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateWorksheetThumbnailResponse = models.StatusMessageBase;
type ApicreateWorksheetThumbnailMutationParams = Parameters<typeof sqWorkbooksApi.createWorksheetThumbnail> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.createWorksheetThumbnail>;

export function useApiCreateWorksheetThumbnailMutation(
  options?: Omit<UseMutationOptions<ApiCreateWorksheetThumbnailResponse, AxiosError<SeeqErrorData>,
    ApicreateWorksheetThumbnailMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateWorksheetThumbnailResponse, AxiosError<SeeqErrorData>,
  ApicreateWorksheetThumbnailMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApicreateWorksheetThumbnailMutationParams) =>
      sqWorkbooksApi.createWorksheetThumbnail(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiCreateWorkstepResponse = models.WorkstepOutputV1;
type ApicreateWorkstepMutationParams = Parameters<typeof sqWorkbooksApi.createWorkstep> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.createWorkstep>;

export function useApiCreateWorkstepMutation(
  options?: Omit<UseMutationOptions<ApiCreateWorkstepResponse, AxiosError<SeeqErrorData>,
    ApicreateWorkstepMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiCreateWorkstepResponse, AxiosError<SeeqErrorData>,
  ApicreateWorkstepMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    mutationFn: (params: ApicreateWorkstepMutationParams) =>
      sqWorkbooksApi.createWorkstep(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiGetRecentlyAccessedResponse = models.ItemSearchPreviewListV1;
export function GetRecentlyAccessedQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getRecentlyAccessed>[0],
) {
  return ['sqWorkbooksApi', 'getRecentlyAccessed', params] as const;
}

export function useApiGetRecentlyAccessedQuery(
  params: Parameters<typeof sqWorkbooksApi.getRecentlyAccessed>[0],
  options?: Omit<UseQueryOptions<ApiGetRecentlyAccessedResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetRecentlyAccessedResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetRecentlyAccessedQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getRecentlyAccessed(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetReferencedItemsResponse = models.ReferencedItemsOutputV1;
export function GetReferencedItemsQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getReferencedItems>[0],
) {
  return ['sqWorkbooksApi', 'getReferencedItems', params] as const;
}

export function useApiGetReferencedItemsQuery(
  params: Parameters<typeof sqWorkbooksApi.getReferencedItems>[0],
  options?: Omit<UseQueryOptions<ApiGetReferencedItemsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetReferencedItemsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetReferencedItemsQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getReferencedItems(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkbookResponse = models.WorkbookOutputV1;
export function GetWorkbookQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorkbook>[0],
) {
  return ['sqWorkbooksApi', 'getWorkbook', params] as const;
}

export function useApiGetWorkbookQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorkbook>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkbookResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkbookResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkbookQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorkbook(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkbookOwnerResponse = models.WorkbookOwnerOutputV1;
export function GetWorkbookOwnerQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorkbookOwner>[0],
) {
  return ['sqWorkbooksApi', 'getWorkbookOwner', params] as const;
}

export function useApiGetWorkbookOwnerQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorkbookOwner>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkbookOwnerResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkbookOwnerResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkbookOwnerQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorkbookOwner(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkbooksResponse = models.WorkbookOutputListV1;
export function GetWorkbooksQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorkbooks>[0],
) {
  return ['sqWorkbooksApi', 'getWorkbooks', params] as const;
}

export function useApiGetWorkbooksQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorkbooks>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkbooksResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkbooksResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkbooksQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorkbooks(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorksheetResponse = models.WorksheetOutputV1;
export function GetWorksheetQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorksheet>[0],
) {
  return ['sqWorkbooksApi', 'getWorksheet', params] as const;
}

export function useApiGetWorksheetQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorksheet>[0],
  options?: Omit<UseQueryOptions<ApiGetWorksheetResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorksheetResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorksheetQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorksheet(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorksheetThumbnailResponse = string;
export function GetWorksheetThumbnailQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorksheetThumbnail>[0],
) {
  return ['sqWorkbooksApi', 'getWorksheetThumbnail', params] as const;
}

export function useApiGetWorksheetThumbnailQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorksheetThumbnail>[0],
  options?: Omit<UseQueryOptions<ApiGetWorksheetThumbnailResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorksheetThumbnailResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorksheetThumbnailQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorksheetThumbnail(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorksheetUsagesResponse = models.AnnotationListOutputV1;
export function GetWorksheetUsagesQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorksheetUsages>[0],
) {
  return ['sqWorkbooksApi', 'getWorksheetUsages', params] as const;
}

export function useApiGetWorksheetUsagesQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorksheetUsages>[0],
  options?: Omit<UseQueryOptions<ApiGetWorksheetUsagesResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorksheetUsagesResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorksheetUsagesQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorksheetUsages(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorksheetsResponse = models.WorksheetOutputListV1;
export function GetWorksheetsQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorksheets>[0],
) {
  return ['sqWorkbooksApi', 'getWorksheets', params] as const;
}

export function useApiGetWorksheetsQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorksheets>[0],
  options?: Omit<UseQueryOptions<ApiGetWorksheetsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorksheetsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorksheetsQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorksheets(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkstepResponse = models.WorkstepOutputV1;
export function GetWorkstepQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorkstep>[0],
) {
  return ['sqWorkbooksApi', 'getWorkstep', params] as const;
}

export function useApiGetWorkstepQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorkstep>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkstepResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkstepResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkstepQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorkstep(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkstepByIdResponse = models.WorkstepOutputV1;
export function GetWorkstepByIdQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorkstepById>[0],
) {
  return ['sqWorkbooksApi', 'getWorkstepById', params] as const;
}

export function useApiGetWorkstepByIdQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorkstepById>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkstepByIdResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkstepByIdResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkstepByIdQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorkstepById(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiGetWorkstepsResponse = models.WorkstepChronologyOutputV1;
export function GetWorkstepsQueryKey(
  params: Parameters<typeof sqWorkbooksApi.getWorksteps>[0],
) {
  return ['sqWorkbooksApi', 'getWorksteps', params] as const;
}

export function useApiGetWorkstepsQuery(
  params: Parameters<typeof sqWorkbooksApi.getWorksteps>[0],
  options?: Omit<UseQueryOptions<ApiGetWorkstepsResponse, AxiosError<SeeqErrorData>>, 'queryKey' | 'queryFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseQueryResult<ApiGetWorkstepsResponse, AxiosError<SeeqErrorData>> {
  const { axiosInstance, silent, retryOnConflict, ...queryOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const requestConfig: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useQuery({
    queryKey: GetWorkstepsQueryKey(params),
    queryFn: () =>
      sqWorkbooksApi.getWorksteps(params, requestConfig).then(
        (response) => response.data,
      ),
    ...queryOptions,
  });
}
type ApiMoveWorksheetResponse = models.WorksheetOutputV1;
type ApimoveWorksheetMutationParams = Parameters<typeof sqWorkbooksApi.moveWorksheet> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.moveWorksheet>;

export function useApiMoveWorksheetMutation(
  options?: Omit<UseMutationOptions<ApiMoveWorksheetResponse, AxiosError<SeeqErrorData>,
    ApimoveWorksheetMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiMoveWorksheetResponse, AxiosError<SeeqErrorData>,
  ApimoveWorksheetMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApimoveWorksheetMutationParams) =>
      sqWorkbooksApi.moveWorksheet(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetCurrentWorkstepResponse = models.WorkstepOutputV1;
type ApisetCurrentWorkstepMutationParams = Parameters<typeof sqWorkbooksApi.setCurrentWorkstep> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.setCurrentWorkstep>;

export function useApiSetCurrentWorkstepMutation(
  options?: Omit<UseMutationOptions<ApiSetCurrentWorkstepResponse, AxiosError<SeeqErrorData>,
    ApisetCurrentWorkstepMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetCurrentWorkstepResponse, AxiosError<SeeqErrorData>,
  ApisetCurrentWorkstepMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApisetCurrentWorkstepMutationParams) =>
      sqWorkbooksApi.setCurrentWorkstep(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
type ApiSetRendererResponse = models.StatusMessageBase;
type ApisetRendererMutationParams = Parameters<typeof sqWorkbooksApi.setRenderer> extends [...infer P, SeeqRequestOverrides?]
  ? P
  : Parameters<typeof sqWorkbooksApi.setRenderer>;

export function useApiSetRendererMutation(
  options?: Omit<UseMutationOptions<ApiSetRendererResponse, AxiosError<SeeqErrorData>,
    ApisetRendererMutationParams>, 'mutationFn'> & {
    /** Override the axios instance for this hook call. */
    axiosInstance?: AxiosInstance;
    /** Skip pending-request tracking for this hook call. */
    silent?: boolean;
    /** When false, a 409 Conflict is returned to the caller. Omitted requests keep the default conflict retry. */
    retryOnConflict?: boolean;
  },
): UseMutationResult<ApiSetRendererResponse, AxiosError<SeeqErrorData>,
  ApisetRendererMutationParams> {
  const { axiosInstance, silent, retryOnConflict, ...mutationOptions } = options ?? {};
  const { useAxiosInstance } = getRuntime();
  const ctxAxiosInstance = useAxiosInstance();
  const resolvedOverrides: SeeqRequestOverrides = {
    axiosInstance: axiosInstance ?? ctxAxiosInstance,
    silent,
    retryOnConflict,
  };
  return useMutation({
    
    mutationFn: (params: ApisetRendererMutationParams) =>
      sqWorkbooksApi.setRenderer(...params, resolvedOverrides).then((response) => response.data),
    ...mutationOptions,
  });
}
